/* eslint-disable no-console */
import { Component } from 'react';

import { logError, logToServer } from 'middleware/logger';
import LandingSlot from 'containers/LandingSlot';

// We'll use the value below in a dangerouslySetInnerHTML JSX attribute.
// Never put dynamic, unvetted stuff in here! (e.g. `${variable}` interpolation.)
const errorHtmlMsg = '<div style="display: none">Psst, something went wrong while rendering a landing component.  See the console for details.</div>';

// If we use errorHtml on first client load, the dangerouslySetInnerHTML attribute
// signals React to attempt to display the component as it was rendered on the server,
// which gives us a bit more of graceful handling.
const errorHtml = <div dangerouslySetInnerHTML={{ __html: errorHtmlMsg }}></div>;

class ErrorResistantLandingSlot extends Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = {
    hasError: false
  };

  componentDidCatch(error, info) {
    logError(`An error has occurred while rendering a landing component: ${error}`);
    logError(`More information: ${info}`);
    logToServer(`[LANDING] Error while rendering a landing slot: ${error}`);
  }

  render() {
    if (this.state.hasError) {
      return errorHtml;
    }

    const {
      data,
      onLandingComponentClick,
      shouldLazyLoad,
      slotContentTypesList,
      slotHeartsData,
      slotName,
      slotIndex,
      ipStatus
    } = this.props;

    return <LandingSlot
      slotName={slotName}
      slotIndex={slotIndex}
      data={data}
      onLandingComponentClick={onLandingComponentClick}
      slotHeartsData={slotHeartsData}
      shouldLazyLoad={shouldLazyLoad}
      ipStatus={ipStatus}
      slotContentTypesList={slotContentTypesList}/>;
  }
}

export default ErrorResistantLandingSlot;
